<template>
  <div>
    <table-component :dataColumn="dataColumn">
      <template v-slot:header>
        <table-header :title="'ID'" :minWidth="50" />
        <table-header :title="$t('productHistory.username')" :minWidth="120" />
        <table-header :title="$t('productHistory.name')" :minWidth="100" />
        <table-header :title="$t('productHistory.operate')" :minWidth="120" />
        <table-header :title="$t('productHistory.date')" :minWidth="220" />
      </template>

      <template v-slot:body="{ rowData: row, index }">
        <table-cell>{{ index + 1 + (currentPage - 1) * LIMIT }}</table-cell>
        <table-cell>{{ row.admin.userName }}</table-cell>
        <table-cell>{{ row.admin.fullName }}</table-cell>
        <table-cell>{{ EOperationStatus.getTitle(row.actionType) }}</table-cell>
        <table-cell>{{ getFullDate(row.createdAt) }}</table-cell>
      </template>
    </table-component>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { EOperationStatus } from '@/enums/user';
import { LIMIT } from '@/constants/common';
import { getFullDate } from '@/helper';

export default {
  name: 'TableListProductHistory',
  props: {
    dataColumn: Array,
    currentPage: Number,
  },
  data() {
    return {
      productIdSelected: null,
      EOperationStatus,
      LIMIT,
    };
  },
  computed: {
    ...mapGetters('product', ['product']),
  },
  methods: {
    ...mapActions('product', ['getProductList', 'getProductStatistic']),
    getFullDate,
  },
};
</script>
